import { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { emptyForm, IBranchInvoiceMatrix, Table } from "./Table";
import { Form } from "./Form";

export interface IModel {
    open: boolean,
    singleData: IBranchInvoiceMatrix
}

export const BranchInvoicePercentageMatrix = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: emptyForm, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: emptyForm, open: false })
    };


    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}